import BaseApi from '@/api/base-api'
import request from '@/utils/request'

class MerchantOrderApi extends BaseApi {
  captureOrder = (orderId, { totalAmount, comment, merchantId }) => {
    return request({
      method: 'POST',
      path: this.uri + `/${orderId}/capture`,
      data: {
        total_amount: totalAmount,
        comment: comment,
        merchant_id: merchantId,
      },
    })
  }

  cancelOrder = (orderId, { totalAmount, comment, merchantId }) => {
    return request({
      method: 'POST',
      path: this.uri + `/${orderId}/cancel`,
      data: {
        total_amount: totalAmount,
        comment: comment,
        merchant_id: merchantId,
      },
    })
  }

  disputeCancelOrder = (
    orderId,
    { totalAmount, comment, merchantId, disputeId }
  ) => {
    return request({
      method: 'POST',
      path: this.uri + `/${orderId}/cancel`,
      data: {
        total_amount: totalAmount,
        comment: comment,
        merchant_id: merchantId,
        dispute_id: disputeId,
      },
    })
  }

  refundOrder = (orderId, { totalAmount, comment, merchantId }) => {
    return request(
      {
        method: 'POST',
        path: this.uri + `/${orderId}/refund`,
        data: {
          total_amount: totalAmount,
          comment: comment,
          merchant_id: merchantId,
        },
      },
      {
        options: {
          headers: {
            'X-Requested-From': 'partner_portal',
          },
        },
      }
    )
  }

  downloadOrders = (data) => {
    return request(
      {
        timeout: 100000, // ms
        method: 'POST',
        path: this.uri + '/report',
        data: data,
      },
      {
        options: {
          hideMessage: true,
          camelizeRes: false,
        },
      }
    )
  }

  generateDocumentLink = (data) => {
    return request({
      method: 'POST',
      path: this.uri + `/dispute/generate-document-link`,
      data: {
        document_name: data,
      },
    })
  }
}

export default new MerchantOrderApi('/merchants/orders')
